import Link from 'next/link';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { ISubCollectionList } from 'shared/types/ConsumerSearch';
import { UnorderedList } from 'shared/components/UnorderedList';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';

const SearchFilterSubCollectionDesktop = ({
  subCollections,
}: {
  subCollections: ISubCollectionList;
}) => {
  const { pathname, query } = useRouter();
  const isNewSearchPageEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_SEARCH_MICROFRONTEND);

  const currentSubCollectionSlug = query.slug[1] || '';

  if (!subCollections || subCollections.length === 0) return null;

  return (
    <SearchFilterSubCollectionDesktop.Wrapper data-qa="sub_collection_list">
      {subCollections.map((subCollection) => {
        const isSelected = currentSubCollectionSlug === subCollection.collectionSlug;

        const slug = isSelected ? [query.slug[0]] : [query.slug[0], subCollection.collectionSlug];

        const href: any = {
          pathname,
          query: {
            ...query,
            slug,
          },
        };

        if (isNewSearchPageEnabled && !isSelected) {
          href.query.pageNumber = 1;
        }

        const handleOnClick = () => {
          sendTrackingEvent('FILTER_APPLY_TAP', {
            event_context: 'collection',
            filter_name: subCollection.name,
            filter_selection: isSelected,
            collection_slug: subCollection.collectionSlug,
            service_name: isNewSearchPageEnabled ? 'consumer_search' : 'constructor',
          });
        };

        return (
          <li
            data-qa={`sub_collection_item_${subCollection.collectionSlug}`}
            key={subCollection.collectionSlug}
            className={isSelected ? 'selected' : ''}
          >
            <div onClick={handleOnClick} role="presentation">
              <Link href={href} prefetch={false} shallow scroll legacyBehavior>
                {subCollection.name}
              </Link>
            </div>
          </li>
        );
      })}
    </SearchFilterSubCollectionDesktop.Wrapper>
  );
};

SearchFilterSubCollectionDesktop.Wrapper = styled(UnorderedList)`
  li {
    padding-bottom: 4px;
    text-underline-offset: 2px;
  }

  li.selected {
    text-decoration: underline;
  }

  li:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export default SearchFilterSubCollectionDesktop;
